import * as THREE from "three";
import gem01 from "../assets/gems/gem01.svg?raw";
import gem02 from "../assets/gems/gem02.svg?raw";
import gem03 from "../assets/gems/gem03.svg?raw";
import gem04 from "../assets/gems/gem04.svg?raw";
import gem05 from "../assets/gems/gem05.svg?raw";
import gem06 from "../assets/gems/gem06.svg?raw";
import gem07 from "../assets/gems/gem07.svg?raw";
import cursorSvg from "../assets/gems/cursor.svg?raw";

/** Vector artwork from the original game, rasterised at this size so it stays sharp. */
const ART_PX = 256;
/** Each source SVG is drawn at 48 px in the original. */
const SOURCE_PX = "48";

export interface GameTextures {
  readonly gems: readonly THREE.Texture[];
  readonly cursor: THREE.Texture;
}

const GEM_SOURCES = [gem01, gem02, gem03, gem04, gem05, gem06, gem07];

/**
 * The artwork has no viewBox, so enlarging width and height alone would leave it in the top-left
 * corner. Adding a viewBox that matches the source size scales the drawing to fill the texture.
 */
function prepareSvg(source: string): string {
  return source
    .replace(`width="${SOURCE_PX}"`, `width="${ART_PX}" viewBox="0 0 ${SOURCE_PX} ${SOURCE_PX}"`)
    .replace(`height="${SOURCE_PX}"`, `height="${ART_PX}"`);
}

async function loadSvgTexture(loader: THREE.TextureLoader, source: string): Promise<THREE.Texture> {
  const url = URL.createObjectURL(new Blob([prepareSvg(source)], { type: "image/svg+xml" }));
  try {
    const texture = await loader.loadAsync(url);
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.minFilter = THREE.LinearFilter;
    texture.generateMipmaps = false;
    return texture;
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function loadGameTextures(): Promise<GameTextures> {
  const loader = new THREE.TextureLoader();
  const gems = await Promise.all(GEM_SOURCES.map((svg) => loadSvgTexture(loader, svg)));
  const cursor = await loadSvgTexture(loader, cursorSvg);
  return { gems, cursor };
}
